export var API_ORIGIN_LOCAL = 'http://localhost:8081';
export var API_PATHNAME_LOCAL = '/api/v1/placements/';
export var API_PATHNAME_STG_PROD = '/gateway/api/post-office/api/v1/placements/';
export var REMOTE_MODULE_URI_LOCAL = 'http://localhost:9009';
export var REMOTE_MODULE_URI_STG = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
export var REMOTE_MODULE_URI_PROD = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';